import { gaEvent } from 'src/utils'

export type PaymentLinkInteractionEventNames =
  | 'interaction_criar_link_pagamento'
  | 'interaction_link_pagamento'
export type PaymentLinkInteractionOptions =
  //Passo 1 - Informar valor a ser pago
  | 'click:passo-1:continuar'
  | 'input:passo-1:valor-a-ser-pago'
  //Passo 2 - Criar link de pagamento
  | 'input:passo-2:criar-link-pix'
  | 'input:passo-2:criar-link-cartao-de-credito'
  | 'click:passo-2:criar-link-pagamento'
  | 'click:passo-2:simulador-taxa'
  | 'click:passo-2:editar-valor'
  //Simulador de taxas
  | 'input:simulador-taxas:pagamento-a-vista'
  | 'input:simulador-taxas:parcelado-2x'
  | 'input:simulador-taxas:parcelado-3x'
  | 'input:simulador-taxas:repassar-taxa-cliente'
  | 'click:simulador-taxas:criar-link-pagamento'
  | 'click:simulador-taxas:entenda-as-taxas'
  //Passo 3 - Link de pagamento criado
  | 'click:passo-3:copiar-codigo-link-pix'
  | 'click:passo-3:compartilhar-link-pix'
  | 'click:passo-3:compartilhar-link-cartao'
  //Link de pagamento
  | 'input:dados-cartao:numero-do-cartao'
  | 'input:dados-cartao:nome-impresso-no-cartao'
  | 'input:dados-cartao:validade'
  | 'input:dados-cartao:codigo-de-seguranca'
  | 'input:dados-cartao:nome-completo'
  | 'input:dados-cartao:cpf-do-titular-do-cartao'
  | 'input:dados-cartao:telefone'
  | 'input:dados-cartao:email'
  | 'click:dados-cartao:continuar'
  | 'input:dados-endereco:rua-avenida'
  | 'input:dados-endereco:complemento'
  | 'input:dados-endereco:bairro'
  | 'input:dados-endereco:cidade'
  | 'input:dados-endereco:estado'
  | 'click:dados-endereco:continuar'
  | 'click:revisao-dados:confirmar'
  | 'click:pagamento:falar-com-revendedor'
  | 'click:revisao:copiar-codigo-pix'

export type PaymentLinkInteractionEventParams = {
  name: PaymentLinkInteractionEventNames
  interaction: PaymentLinkInteractionOptions
}

function sendToGA4Format({ name, interaction }: PaymentLinkInteractionEventParams) {
  gaEvent({
    event: 'analytics-event',
    event_parameters: {
      event_name: name,
      cd_interaction_detail: interaction,
    },
  })
}

/**
 * Eventos da interação mapeados da criação do link de pagamento
 * Obs: Novo formato para o GA4.
 *
 * [TARGET]: Qualquer evento de interação, como click/input.
 *
 * [CONTEXTO]: No link de pagamento, qualquer interação do usuário que seja relevante para o acompanhamento de eventos.
 *
 * [REGRAS]: n/a
 */
export function sendCreatePaymentLinkEvent(interaction: PaymentLinkInteractionOptions) {
  sendToGA4Format({ name: 'interaction_criar_link_pagamento', interaction })
}

/**
 * Eventos da interação mapeados do link de pagamento.
 * Obs: Novo formato para o GA4.
 *
 * [TARGET]: Qualquer evento de interação, como click/input.
 *
 * [CONTEXTO]: No link de pagamento, qualquer interação do usuário que seja relevante para o acompanhamento de eventos.
 *
 * [REGRAS]: n/a
 */
export function sendPaymentLinkEvent(interaction: PaymentLinkInteractionOptions) {
  sendToGA4Format({ name: 'interaction_link_pagamento', interaction })
}
